export const WhatAreTheComponents = {
  question: "What are the components of a V2MOM?",
  answer: `
1. **Vision**: a high-level overview, usually 3-4 sentences, that sets a clear direction for your work and what impact it’ll have on the business
2. **Values**: 3-4 guiding principles that help you prioritize everything on your V2MOM
3. **Methods**: a collection of projects and work that’ll help you achieve your vision
4. **Obstacles**: a list of blockers or concerns that we should be aware of in order to reach our goals
5. **Measures**: individual tactics and measurable activity that helps us track our progress on our goals and adjust effort throughout the year
`
}